import InboundLimitTierSetDocument from "domain/Transaction/inbound/InboundLimitTierSetDocument";

export default class InboundLimitTierSetDocumentsResponse {

    constructor(jsonResponse) {

        this.limitIncreaseRequired = jsonResponse["limit-increase-required"];
        this.limitTierSet = jsonResponse["limit-tier-set"];

        let requiredDocuments =  jsonResponse["required-documents"] || [];
        this.requiredDocuments = [];
        requiredDocuments.forEach(singleDocument=>{
            this.requiredDocuments.push(new InboundLimitTierSetDocument(singleDocument));
        })

    }

}